import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest } from "redux-saga/effects";
import { clearErrors, returnErrors } from "../actions/errorAction";
import { uploadedAuctionInvListFailure, uploadedAuctionInvListSuccess } from "../actions/fetchAuctionUploadedInventoryListAction";


function* asyncFetchUploadedAuctionInvRequestSaga(action){

    try{
    yield put(clearErrors());
    let uploadedAuctionInvResult = yield call(_api.fetchuploadedAuctionInvRequestApi,{
        accessToken: action.payload.accessToken,
        auction_id:action.payload.auction_id,
    })
     yield put(uploadedAuctionInvListSuccess({uploadedAuctionInvResult}));
    }catch(e){
        yield put(uploadedAuctionInvListFailure({error:e}));
        yield put(returnErrors({msg:e.message, status: true}))
    }
}

export default function* fetchUploadedAuctionInvRequestSaga(){
    yield takeLatest(types.FETCH_UPLOADED_AUCTION_INVENTORY_REQUEST,asyncFetchUploadedAuctionInvRequestSaga)
}